import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import Tag from '../components/Tag';

const Projects = () => {
  const { t } = useTranslation();
  const projects = t('projects.items', { returnObjects: true });

  return (
    <div>
      <PageHeader eyebrow="Kalle Glauch" title={t('projects.title')} lead={t('projects.lead')} />

      <div className="mx-auto max-w-5xl px-6 py-14 md:px-10 md:py-16">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {Array.isArray(projects) &&
            projects.map((project, index) => (
              <motion.article
                key={index}
                className="flex flex-col rounded-md border border-line bg-beige-50 p-7"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.4, delay: (index % 2) * 0.06 }}
              >
                <div className="mb-3 flex items-center gap-2">
                  <Tag>{project.technology}</Tag>
                  {project.date && <span className="text-xs tracking-wide text-ink-400">{project.date}</span>}
                </div>
                <h2 className="text-base font-semibold leading-snug text-ink-900">{project.title}</h2>
                <p className="mt-2 flex-grow text-sm leading-relaxed text-ink-600">{project.description}</p>
                {project.link && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-navy-600 transition-colors hover:text-navy-800"
                  >
                    {t('projects.viewProject')}
                    <ArrowUpRight size={15} />
                  </a>
                )}
              </motion.article>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
